import React, { useState } from 'react';
import { NavBarLogo } from './Logo';
import { NavBarLinks } from './Links';
import styled, { css } from 'styled-components';
import { cssColorValue, KeyboardDetectionProvider, screenMdMin, screenXsMin, spacer16, spacer4, spacer40, spacer48, } from '@spotify-internal/encore-web';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useScrollYPosition } from '../../utils/useScrollYPosition';
import { NavBarActionsWithLanguage } from './ActionsWithLanguage';
import { Wait } from './Wait';
import { NavBarSideMenuWrapper } from './SideMenuWrapper';
import { useUserState } from './hooks/useUserState';
import { useS4AMastheadContext } from '../S4AMastheadProvider';
import { MAX_CONTENT_WIDTH } from '../constants';
const NavBarWrapper = styled.header `
  align-items: center;
  box-sizing: border-box;
  background: ${props => {
    var _a, _b, _c;
    return props.isScrolling
        ? ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.background) ||
            ((_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.nav) === null || _c === void 0 ? void 0 : _c.background) ||
            cssColorValue('backgroundBase')
        : 'transparent';
}};
  color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
  display: flex;
  justify-content: space-between;
  padding-block: 18px;
  padding-inline: ${spacer40};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  ${({ colors, theme }) => {
    var _a;
    return !(colors === null || colors === void 0 ? void 0 : colors.bleed) &&
        css `
      background: ${(colors === null || colors === void 0 ? void 0 : colors.background) ||
            ((_a = theme === null || theme === void 0 ? void 0 : theme.nav) === null || _a === void 0 ? void 0 : _a.background) ||
            cssColorValue('backgroundBase')};
    `;
}};

  @media (max-width: ${screenMdMin}) {
    padding-block: ${spacer4};
    transition: transform 400ms ease-in-out;
    -webkit-transition: -webkit-transform 400ms ease-in-out;
    transform: ${props => (props.isScrollingUp ? 'none' : 'translateY(-60px)')};
  }

  @media (max-width: ${screenXsMin}) {
    padding-inline: ${spacer16};
  }

  @media (min-width: 1520px) {
    padding-inline: ${spacer48};
  }
  // max content width of 1520px
  @media (min-width: ${MAX_CONTENT_WIDTH}) {
    padding-inline: calc((100% - 1520px) / 2);
  }
`;
export const NavBar = ({ colors, forcedUserState, className }) => {
    const [showNavBarMobile, setShowNavBarMobile] = useState(true);
    const scrollPos = useScrollYPosition();
    const userState = useUserState(forcedUserState);
    const { language, mastheadData } = useS4AMastheadContext();
    useScrollPosition(({ prevPos, currPos }) => {
        setShowNavBarMobile(currPos.y > prevPos.y || currPos.y > -1);
    }, []);
    if (userState === 'loading' || !mastheadData) {
        return React.createElement(Wait, null);
    }
    const headerEntry = mastheadData.fields.header;
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(NavBarWrapper, { className: className, role: "banner", colors: colors, isScrolling: scrollPos !== 0, isScrollingUp: showNavBarMobile, "data-testid": `navbar-state-${userState}` },
            React.createElement(NavBarLogo, { colors: colors, headerEntry: headerEntry }),
            React.createElement(NavBarLinks, { colors: colors, mastheadData: mastheadData, entries: headerEntry.fields.centerNav }),
            React.createElement(NavBarActionsWithLanguage, { colors: colors, language: language, userState: userState, mastheadData: mastheadData }),
            React.createElement(NavBarSideMenuWrapper, { colors: colors, language: language, userState: userState, mastheadData: mastheadData }))));
};
//# sourceMappingURL=NavBar.js.map